export default __webpack_public_path__ + "static/media/discord.99982df8.png";